import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _isEmpty from 'lodash.isempty';

import request from 'actions/request';
import redirect from 'actions/redirect';

class ShowChartByTemplates extends React.Component {
  buildButton() {
    if (_isEmpty(this.props.trackTemplates.chosenItems)) {
      return '';
    }

    return <span
      className="glyphicon glyphicon-picture"
      aria-hidden="true">
    </span>;
  }

  showChart() {
    if (this.props.trackTemplates.chosenItems.length === 1) {
      this.props.redirect('/chart/'
        + 'track-id/'+ this.props.trackId + '/'
        + 'template-id/'+ this.props.trackTemplates.chosenItems[0].id + '/'
        + 'from-frame/'+ this.props.startFrame + '/'
        + 'to-frame/'+ this.props.endFrame
      );
    } else if (this.props.trackTemplates.chosenItems.length > 1) {
      let templateName = 'last';
      this.props.request(
        ['trackTemplate', 'merge'],
        'post',
        'TEMPLATES_MERGE',
        {
          trackId: this.props.trackId,
          resultTemplateName: templateName,
          templatesToMerge: JSON.stringify(this.props.trackTemplates.chosenItems)
        }
      ).then((resp) => {
        this.props.redirect('/chart/'
          + 'track-id/'+ this.props.trackId + '/'
          + 'template-id/'+ resp.id + '/'
          + 'from-frame/'+ this.props.startFrame + '/'
          + 'to-frame/'+ this.props.endFrame
        );
      });
    }
  }

  render() {
    return <ul className="nav navbar-nav navbar-right">
      <li><a href="#" onClick={ this.showChart.bind(this) }>
        { this.buildButton() }
      </a></li>
    </ul>;
  }
}

function mapStateToProps(state) {
  return {
    trackTemplates: state.trackTemplates,
    startFrame: state.track.selectedStartFrame,
    endFrame: state.track.selectedEndFrame
  }
}

function mapDispatchToProps(dispatch) {
  return {
    request: bindActionCreators(request, dispatch),
    redirect: bindActionCreators(redirect, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ShowChartByTemplates);
